import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4000Model } from '../kymw4000.model';
import { KYMW4000OutputModel } from '../vo/kymw4000-output.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 週次プロモーション商品計画表画面　週次プロモーション商品計画表を出力するサービス
 *
 * @export OutputPromotionPlanGoodsListService
 * @class OutputPromotionPlanGoodsListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputPromotionPlanGoodsListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW4000Model}
   * @memberof OutputPromotionPlanGoodsListService
   */
  private model: KYMW4000Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW4000OutputModel}
   * @memberof OutputPromotionPlanGoodsListService
   */
  private vo: KYMW4000OutputModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof OutputPromotionPlanGoodsListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputPromotionPlanGoodsListService
   */
  private getBody(): PlessRequest {
    return new  PlessRequest ({
      parameter: {
        StartOrderCode: this.vo.startOrderCode,
        EndOrderCode: this.vo.endOrderCode,
        PromotionNo: this.vo.promotionNo
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof OutputPromotionPlanGoodsListService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW4000Model>model;
    this.vo = <KYMW4000OutputModel>vo;
    this.successFunc = successFunc;
    this.send('KYMW40outputPromotionPlanGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputPromotionPlanGoodsListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
